/*
 * Switch block actions:
 */
export const FLOW_DESIGNER_SWITCH_BLOCK_MODIFY =
  'FLOW_DESIGNER_SWITCH_BLOCK_MODIFY';
export const modifySwitchBlock = ({ blockId, label, property }) => ({
  type: FLOW_DESIGNER_SWITCH_BLOCK_MODIFY,
  payload: {
    blockId,
    label,
    property,
  },
});

/*
 * Switch case (sub-block) actions:
 */
export const FLOW_DESIGNER_SWITCH_CASE_ADD = 'FLOW_DESIGNER_SWITCH_CASE_ADD';
export const FLOW_DESIGNER_SWITCH_CASE_REMOVE =
  'FLOW_DESIGNER_SWITCH_CASE_REMOVE';
export const FLOW_DESIGNER_SWITCH_CASE_MODIFY =
  'FLOW_DESIGNER_SWITCH_CASE_MODIFY';

export const addSwitchCase = ({ blockId, orderNum, value = null }) => ({
  type: FLOW_DESIGNER_SWITCH_CASE_ADD,
  payload: { blockId, orderNum, value },
});

export const deleteSwitchCase = ({ id }) => ({
  type: FLOW_DESIGNER_SWITCH_CASE_REMOVE,
  payload: { id },
});

export const modifySwitchCase = ({ id, value }) => ({
  type: FLOW_DESIGNER_SWITCH_CASE_MODIFY,
  payload: {
    id,
    value,
  },
});
